import apiFetch from '../apiFetch'
export default function (companyId, token, includeDeleted = false, selectedValue) {
  return apiFetch({ endPoint: `FinancingType/${companyId}?includeDeleted=${includeDeleted}&selectedValue=${selectedValue}`, method: 'GET', body: null, token: token })
}
